export default __webpack_public_path__ + "static/media/yes.2e1636b3.svg";